import React, {useEffect, useState} from "react";
import Select from "react-select";
import cx from "classnames";
import {ITableSortingOption} from "@components/elements/tables/ITableSortingOption";

export function SelectField(
    props: {
        id: string,
        className: string,
        placeholder: string,
        value: ITableSortingOption | undefined,
        onChange: (e: ITableSortingOption) => void,
        options: ITableSortingOption[],
    }) {

    const [value, setValue] = useState<ITableSortingOption | undefined>(props.value);

    useEffect(() => setValue(props.value), [props.value]);

    const getOptions = (): { value: ITableSortingOption, label: string }[] => {
        return props.options.map((option) => {
            return {value: option, label: option.getLabel()}
        });
    }

    const convertITableSortingOptiontoOption = (input: ITableSortingOption | undefined): { value: any, label: string } | undefined => {
        if (input) {
            return {value: input, label: input.getLabel()}
        }
        return undefined;
    }

    return (
        <div className={props.className}>
            <Select
                id={props.id}
                instanceId={props.id}
                classNamePrefix={props.id}
                className={cx("w-full", "h-full", "text-gray-900 dark:text-gray-100", "rounded-md", "bg-gray-100 border border-2", "dark:bg-gray-500 dark:border-gray-700 dark:text-gray-100")}
                placeholder={props.placeholder}
                options={getOptions()}
                onChange={(e) => {
                    setValue(e?.value);
                    props.onChange(e?.value);
                }}
                value={convertITableSortingOptiontoOption(value)}
            />
            {/* eslint-disable-next-line react/no-unknown-property */}
            <style global jsx>{`
              #${props.id} .${props.id}__control {
                height: 100%;
              }

              .dark #${props.id} .${props.id}__control,
              :root[data-theme='dark'] #${props.id} .${props.id}__control {
                background-color: #6b727f !important;
                border-color: #2b2b2b00;
                padding: 4px;
                height: 100%;
              }

              .dark #${props.id} .${props.id}__single-value,
              :root[data-theme='dark'] #${props.id} .${props.id}__single-value {
                color: #d1d5db !important;
              }

              .dark #${props.id} .${props.id}__placeholder,
              :root[data-theme='dark'] #${props.id} .${props.id}__placeholder {
                color: #d1d5db !important;
              }

              .dark #${props.id} .${props.id}__multi-value,
              :root[data-theme='dark'] #${props.id} .${props.id}__multi-value {
                background-color: slategray;
                color: #fff;
              }

              .dark #${props.id} .${props.id}__input-container,
              :root[data-theme='dark'] #${props.id} .${props.id}__input-container {
                color: #d1d5db;
                border: none;
              }

              .dark #${props.id} .${props.id}__input-container:focus,
              :root[data-theme='dark'] #${props.id} .${props.id}__input-container:focus {
                border: none !important;
                outline: none !important;
              }

              .dark #${props.id} .${props.id}__input:focus,
              :root[data-theme='dark'] #${props.id} .${props.id}__input:focus {
                border: none !important;
                outline: none !important;
              }

              .dark #${props.id} .${props.id}__input::after,
              :root[data-theme='dark'] #${props.id} .${props.id}__input::after {
                border: none !important;
                display: none;
              }

              .dark #${props.id} .${props.id}__multi-value__label,
              :root[data-theme='dark'] #${props.id} .${props.id}__multi-value__label {
                color: #fff;
              }

              .dark #${props.id} .${props.id}__menu,
              :root[data-theme='dark'] #${props.id} .${props.id}__menu {
                background-color: #2d3748;
              }

              .dark #${props.id} .${props.id}__option,
              :root[data-theme='dark'] #${props.id} .${props.id}__option {
                color: #fff;
              }

              .dark #${props.id} .${props.id}__option--is-focused,
              :root[data-theme='dark'] #${props.id} .${props.id}__option--is-focused {
                background-color: slategray;
              }
            `}</style>
        </div>
    )
}
